import { createSlice } from '@reduxjs/toolkit';
import { addCoupon, fetchAllCoupons } from './couponsThunk';
import { API_STATUS_TYPE } from '../../../utils/contants';

const INITIAL_STATE = {
  name: 'coupons',
  coupons: [],
  isLoading: false,
  error: null
};

const couponSlice = createSlice({
  name: 'coupons',
  initialState: INITIAL_STATE,
  extraReducers: (builder) => {
    builder

      .addCase(addCoupon.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })
      .addCase(fetchAllCoupons.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.coupons = action.payload.data.map((item) => ({
          ...item,
          translationsMap: Array.isArray(item.translations)
            ? item.translations.reduce((acc, t) => {
                if (t && t.languageCode) {
                  acc[t.languageCode] = {
                    title: t.title ?? '',
                    image: t.image ?? ""
                  };
                }
                return acc;
              }, {})
            : {}
        }));
      })

      // Pending Matcher
      .addMatcher(
        (action) => action.type.startsWith('coupon/') && action.type.endsWith('/pending'),
        (state) => {
          state.isLoading = true;
          state.status = API_STATUS_TYPE.PENDING;
          state.error = null;
        }
      )

      // Rejected Matcher
      .addMatcher(
        (action) => action.type.startsWith('coupon/') && action.type.endsWith('/rejected'),
        (state, action) => {
          state.isLoading = false;
          state.status = API_STATUS_TYPE.FAILED;
          state.error = action.payload || 'An unexpected error occurred';
        }
      );
  }
});

export const {} = couponSlice.actions;

export default couponSlice.reducer;
